<template>
	<el-dialog title="所属机构选择" :visible.sync="dialogVisible" width="50%" :before-close="() => {
			$emit('update:dialogVisible', false);
			$refs.multipleTable.clearSelection();
		}
		">
		<div>
			<span>机构全称:</span>
			<el-input style="width:20%;margin:0 10px;" placeholder="请输入机构全称" v-model="params.fullName"></el-input>

			<el-button type="primary" @click="() => {
					params.fullName = '';
					params.pageNo = 1;
					getFinancialOrganizetionList();
				}
				">清空条件</el-button>
			<el-button type="primary" @click="() => {
					params.pageNo = 1;
					getFinancialOrganizetionList();
				}
				">查询</el-button>
		</div>
		<div style="padding:20px 0">
			<el-table border height="250" ref="multipleTable" :data="branchList" tooltip-effect="dark" style="width: 100%"
				highlight-current-row :header-cell-style="{ background: '#ecf5ff' }" @selection-change="handleSelectionChange"
				@row-click="(row) => $refs.multipleTable.toggleRowSelection(row)
					">
				<el-table-column type="selection" width="55"> </el-table-column>
				<el-table-column label="机构简称" prop="shortName">
				</el-table-column>
				<el-table-column width="240" prop="fullName" label="机构全称">
				</el-table-column>
				<el-table-column prop="organizationTypeName" label="机构类别">
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: end;">
			<el-pagination @current-change="currentChange" background layout="prev, pager, next" :total="total">
			</el-pagination>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="$emit('update:dialogVisible', false)">取 消</el-button>
			<el-button type="primary" @click="() => {
					$emit('update:dialogVisible', false);
					$emit(
						'selectFinancialOrganizetionList',
						multipleSelection
					);
					$refs.multipleTable.clearSelection();
				}
				">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { financialOrganizetionList } from '@/api/index.js';
export default {
	name: 'branchDialog',
	props: {
		dialogVisible: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			branchList: [],
			multipleSelection: [],
			params: {
				pageSize: 10,
				pageNo: 1,
				// sortFlag: 'financialOrganizationsId-asc',
				fullName: '',
			},
			total: 0,
		};
	},
	methods: {
		async getFinancialOrganizetionList() {
			const res = await financialOrganizetionList(this.params);
			if (res.returncode === 0) {
				this.branchList = res.list;
				this.total = res.totalRows;
			}
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			if (val.length > 1) {
				this.$refs.multipleTable.clearSelection(); //清除
				this.$refs.multipleTable.toggleRowSelection(val.pop()); //pop：最后一个
			} else {
				this.multipleSelection = val; //multipleSelection：当前选择的数组
			}
		},
		currentChange(val) {
			this.params.pageNo = val;
			this.getFinancialOrganizetionList();
		},
	},
	created() {
		// 网点
		this.getFinancialOrganizetionList();
	},
};
</script>
<style lang="scss" scoped>
::v-deep thead {
	.el-table-column--selection {
		.cell {
			display: none;
		}
	}
}
</style>
